import { PageContainer } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { createFileRoute } from "@tanstack/react-router";
import { fetchManageUserAssignConditions } from "../../../../services/assignConditions";
import { UserWeeklyGoals } from "./-internal-components/UserWeeklyGoals";

const RouteComponent: React.FC = () => {
  const manageUserAssignConditions = Route.useLoaderData();

  return (
    <PageContainer
      showBackButton
      title={manageUserAssignConditions?.full_name_with_login || ""}
    >
      <UserWeeklyGoals userId={String(manageUserAssignConditions.id)} />
    </PageContainer>
  );
};

export const Route = createFileRoute(
  "/_private/mm_request_weekly_goals/$userId/",
)({
  component: RouteComponent,
  loader: ({ params: { userId } }) => fetchManageUserAssignConditions(userId),
});
